import * as Nav from './nav';
import * as Home from './home';
import * as ClassesAndWorkshops from './classes-and-workshops';
import * as Resources from './resources';
import elementDatasetPolyfill from 'element-dataset';

(() => {
	elementDatasetPolyfill();

	const onLoad = () => {
		Nav.onLoad();
		Home.onLoad();
		ClassesAndWorkshops.onLoad();
		Resources.onLoad();
	};

	// Only initialize if the document has been loaded
	if (document.readyState !== 'loading')
		onLoad();
	else
		document.addEventListener('DOMContentLoaded', onLoad);
})();



// WEBPACK FOOTER //
// ./assets/scripts/main.js